export default {
    profile: 'profile',
    user: 'master/user',
    language: 'master/language',
    product: 'master/product',
    client: 'master/client',
    pic: 'master/pic',
    dashboard: 'dashboard',
    project: 'project',
}